import {PayMethod} from "../types/types";


export const payCode = (code: PayMethod) => {
    switch (code) {
        case 'TRANSFER':
            return 'trans';
        case 'VIRTUAL_ACCOUNT':
            return 'vbank';
        case 'KAKAO':
            return 'kakaopay';
        case 'NAVER':
            return 'naverpay';
        default:
            return 'card';
    }
}